import {startOrResetInterval} from '../../helpers'

export const handleStartOrReset = ({intervalRef, interval, elements, setActiveIndex}) => {
	startOrResetInterval({
		ref: intervalRef,
		interval,
		callbackFn: () => setActiveIndex(prevState => (prevState > elements.length - 2 ? 0 : prevState + 1)),
	})
}
